// Per-variant exports — import only what you actually use so webpack
// bundles just those font files. The full roster lives here for discovery;
// consumer imports are the optimization signal.
export { ppMoriExtraLight } from './ExtraLight';
export { ppMoriExtraLightItalic } from './ExtraLightItalic';
export { ppMoriLight } from './Light';
export { ppMoriLightItalic } from './LightItalic';
export { ppMoriBook } from './Book';
export { ppMoriBookItalic } from './BookItalic';
export { ppMoriRegular } from './Regular';
export { ppMoriRegularItalic } from './RegularItalic';
export { ppMoriMedium } from './Medium';
export { ppMoriMediumItalic } from './MediumItalic';
export { ppMoriSemiBold } from './SemiBold';
export { ppMoriSemiBoldItalic } from './SemiBoldItalic';
export { ppMoriBold } from './Bold';
export { ppMoriBoldItalic } from './BoldItalic';
export { ppMoriExtraBold } from './ExtraBold';
export { ppMoriExtraBoldItalic } from './ExtraBoldItalic';
